import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconSettingsSlider';
/** Renders an SVG icon. */
const SvgSettingsSlider = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M22 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.874 1a4.002 4.002 0 0 1 7.748 0H27a1 1 0 1 1 0 2h-1.126a4.002 4.002 0 0 1-7.748 0H5a1 1 0 0 1 0-2zM10 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.874 1a4.002 4.002 0 0 1 7.748 0H27a1 1 0 1 1 0 2H13.874a4.002 4.002 0 0 1-7.748 0H5a1 1 0 1 1 0-2zM19 22a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.874 1a4.002 4.002 0 0 1 7.748 0H27a1 1 0 1 1 0 2h-4.126a4.002 4.002 0 0 1-7.748 0H5a1 1 0 1 1 0-2z"
      />
    </svg>
  );
};
SvgSettingsSlider.displayName = displayName;
export default SvgSettingsSlider;
